import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Spraynasal = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.23 83.08">
  <G fill={color}>
    <Path d="M38.8,43.88l-5.03-8.41c-.54-.91-1.52-1.46-2.57-1.46h-1.92v-3.4h6.59c1.66,0,3-1.34,3-3s-1.34-3-3-3h-8.07l-2.37-21.93c-.16-1.52-1.45-2.68-2.98-2.68h-6.84c-1.53,0-2.82,1.15-2.98,2.68l-2.37,21.93H3.36c-1.66,0-3,1.34-3,3s1.34,3,3,3h6.59v3.4h-1.92c-1.06,0-2.03.55-2.58,1.46L.42,43.88c-.28.47-.42,1-.42,1.54v30.5c0,3.94,3.21,7.15,7.15,7.15h24.92c3.95,0,7.15-3.21,7.15-7.15v-30.5c0-.54-.15-1.07-.43-1.54ZM18.3,6h1.46l2.01,18.61h-5.48l2.01-18.61ZM15.95,30.61h7.34v3.4h-7.34v-3.4ZM27.56,68.51c0,1.66-1.34,3-3,3h-9.89c-1.66,0-3-1.34-3-3v-16.3c0-1.66,1.34-3,3-3h9.89c1.66,0,3,1.34,3,3v16.3Z"/>
  </G>
</Svg>
);
};

export default Spraynasal;
